var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.49 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #afb1b3;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.24,16.98c-3.71,0-6.73-3.02-6.73-6.73v-3.51C3.51,3.02,6.53,0,10.24,0s6.73,3.02,6.73,6.73v3.51c0,3.71-3.02,6.73-6.73,6.73ZM10.24,1.76c-2.74,0-4.98,2.23-4.98,4.98v3.51c0,2.74,2.23,4.98,4.98,4.98s4.98-2.23,4.98-4.98v-3.51c0-2.74-2.23-4.98-4.98-4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.1,7.61h-4.68c-.48,0-.88-.39-.88-.88s.39-.88.88-.88h4.68c.48,0,.88.39.88.88s-.39.88-.88.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.1,11.12h-4.68c-.48,0-.88-.39-.88-.88s.39-.88.88-.88h4.68c.48,0,.88.39.88.88s-.39.88-.88.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.24,20.49C4.6,20.49,0,15.89,0,10.24v-1.17c0-.48.39-.88.88-.88s.88.39.88.88v1.17c0,4.68,3.81,8.49,8.49,8.49s8.49-3.81,8.49-8.49v-1.17c0-.48.39-.88.88-.88s.88.39.88.88v1.17c0,5.65-4.6,10.24-10.24,10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.24,24c-.48,0-.88-.39-.88-.88v-3.51c0-.48.39-.88.88-.88s.88.39.88.88v3.51c0,.48-.39.88-.88.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.2eff2394396e70635853686078c6492a.svg";
export { ForwardRef as ReactComponent };